import { render, staticRenderFns } from "./ItemTabFiles.vue?vue&type=template&id=775bd797&"
import script from "./ItemTabFiles.vue?vue&type=script&lang=js&"
export * from "./ItemTabFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports